import { cn } from "@devhop/ui";
import { Factory, Layers2, ShoppingBag, type LucideIcon } from "lucide-react";
import { PRODUCT_KIND_LABELS, type ProductKind } from "./product-kind";

const KIND_ICONS: Record<ProductKind, LucideIcon> = {
  retail: ShoppingBag,
  production: Factory,
  hybrid: Layers2,
};

const KIND_OPTIONS = (["retail", "production", "hybrid"] as const).map(
  (value) => ({
    value,
    icon: KIND_ICONS[value],
    ...PRODUCT_KIND_LABELS[value],
  }),
);

type ProductKindRadioProps = {
  value: ProductKind;
  onChange: (value: ProductKind) => void;
  disabled?: boolean;
};

export function ProductKindRadio({
  value,
  onChange,
  disabled,
}: ProductKindRadioProps) {
  return (
    <div
      role="radiogroup"
      aria-label="ປະເພດສິນຄ້າ"
      data-tourid="product-form-kind"
      className="grid grid-cols-1 gap-3 sm:grid-cols-3"
    >
      {KIND_OPTIONS.map((opt) => {
        const selected = value === opt.value;
        const Icon = opt.icon;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={selected}
            disabled={disabled}
            onClick={() => onChange(opt.value)}
            className={cn(
              "flex flex-col items-start gap-2 rounded-lg border p-4 text-left transition-colors",
              "disabled:cursor-not-allowed disabled:opacity-50",
              selected
                ? "border-foreground bg-foreground/5 ring-1 ring-foreground"
                : "border-border bg-background hover:border-foreground/40",
            )}
          >
            <Icon
              className={cn(
                "size-5 shrink-0",
                selected ? "text-foreground" : "text-muted-foreground",
              )}
              aria-hidden
            />
            <span className="font-medium text-foreground text-sm leading-snug">
              {opt.label}
            </span>
            <span className="text-muted-foreground text-xs leading-relaxed">
              {opt.hint}
            </span>
          </button>
        );
      })}
    </div>
  );
}
